export class AssignmentSummaryCriteriaV2 {
    resourceId: number;
}
